module.exports = __webpack_public_path__ + "img/execution.8563c277.gif";